export const SIZES = {
  FREIGHT_RATE_STANDARD_SIZE: 100,
};
